import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstanceMainUrl from "../../../utils/axiosInstanceMainUrl";

export const userListApi = createAsyncThunk("userList", async () => {
  const response = await axiosInstanceMainUrl.get(`/payout/getApproverList`);
  return response.data;
});

const userListSlice = createSlice({
  name: "userList",
  initialState: {
    userList: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userListApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(userListApi.fulfilled, (state, action) => {
        state.userList = action.payload;
        state.loading = false;
      })
      .addCase(userListApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default userListSlice.reducer;
